import Checkbox from "../../../../../src/entities/UI/Checkbox/Checkbox";
import BaseSliderManager from "../../../../../src/managers/BaseSliderManager/BaseSliderManager";
import { SliderGenProps } from "../../../../../src/types/Interface";
import { SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL } from "../types/Config";
import { eventBus, EnumEventBus } from "./EventBus";


const SliderGen: SliderGenProps[] = [
    {
        head: "move circumference point",
        colors: {
            bgColor: 0xB5A1FF,
            barColor: 0x000000,
            buttonColor: 0xB5A1FF
        },
        onUpdate: (v: number) => eventBus.emit(EnumEventBus.moveCircumPoint, v - 100)
    },
]


export default class SliderManager extends BaseSliderManager {
    pointCheckboxes: Checkbox[] = [];
    pointChecklist: boolean[] = Array(2).fill(false);

    constructor() {
        super(SliderGen, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL);
    }
}

